import { dispatch } from '../store';
import * as toolkitRaw from '@reduxjs/toolkit';
import { appVersion, countryList, varietyList } from '@/services';
const { createSlice } = toolkitRaw.default ?? toolkitRaw;
import { getAlgInfo as getAlgInfoService } from '@/services'

// ----------------------------------------------------------------------

const initialState = {
  loading: {},
  countries: [],
  varieties: [],
  pageTitle: '',
  contractConf: null,
  locationInfo: null,
  currency: "",
  signinModalShow: false,
  bindEmailModalShow: false,
  accountDrawerOpen: false,
  appVersion: null,

  // 缓存滚动list records和scroll bar position
  scrollPageStorage: {},
  walletDrawerOpen: false,
};

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    startLoading(state, { payload: type }) {
      const loading = state.loading;
      loading[type] = true;
      state.loading = { ...loading };
    },
    stopLoading(state, { payload: type }) {
      const loading = state.loading;
      loading[type] = false;
      state.loading = { ...loading };
    },
    onPageTitle(state, { payload: pageTitle }) {
      state.pageTitle = pageTitle;
    },
    onGetCountries(state, { payload: res }) {
      state.countries = res?.list?.filter?.(country => country.isSupport) || [];
    },
    onGetVarieties(state, { payload: res }) {
      state.varieties = res?.list || [];
    },
    onAppVersion(state, { payload }) {
      state.appVersion = payload || null;
    },
    onToggleAccountDrawerOpen(state) {
      state.accountDrawerOpen = !state.accountDrawerOpen;
    },
    onAccountDrawerClose(state) {
      state.accountDrawerOpen = false;
    },
    setScrollPageStorage(state, { payload }) {
      state.scrollPageStorage = { ...state.scrollPageStorage, ...(payload ?? {}) }
    },
    onToggleWalletDrawerOpen(state) {
      state.walletDrawerOpen = !state.walletDrawerOpen;
    },
    onWalletDrawerClose(state) {
      state.walletDrawerOpen = false;
    },
    onAlgInfo(state, { payload: res }) {
      state.algInfo = res;
      localStorage.setItem('algInfo', JSON.stringify({
        ...res
      }))
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  stopLoading,
  onAppVersion,
  onGetCountries,
  onGetVarieties,
  onPageTitle,
  onToggleAccountDrawerOpen,
  onAccountDrawerClose,
  setScrollPageStorage,
  onToggleWalletDrawerOpen,
  onWalletDrawerClose,
  onAlgInfo
} = slice.actions;

// ----------------------------------------------------------------------
export function initAppData() {
  dispatch(getAppVersion());
  dispatch(getCountries());
  // dispatch(getVarieties());
}

export function getAppVersion() {
  return async () => {
    try {
      const responseData = await appVersion();
      dispatch(slice.actions.onAppVersion(responseData));
    } catch {
    }
  };
}

export function getCountries() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getCountries'));
      const responseData = await countryList();
      dispatch(slice.actions.onGetCountries(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getCountries'));
    }
  };
}

export function getVarieties() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getVarieties'));
      const responseData = await varietyList();
      dispatch(slice.actions.onGetVarieties(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getVarieties'));
    }
  };
}
export function getAlgInfo() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getAlgInfo'));
      let algInfo = localStorage.getItem('algInfo')
      if (algInfo) {
        algInfo = JSON.parse(algInfo);
        if (algInfo?.sa && algInfo?.se) {
          dispatch(slice.actions.onAlgInfo(algInfo));
        }
      } else {
        const responseData = await getAlgInfoService();
        dispatch(slice.actions.onAlgInfo({ se: responseData.se, sa: 'web_0' }));
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      dispatch(slice.actions.stopLoading('getAlgInfo'));
    }
  };
}